module.exports = __webpack_public_path__ + "static/media/logoMerxFooter.2031a1c4.svg";